import sales from './sales';
import actuarial from './actuarial';



export default [
    sales,
    actuarial
];
